import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import CssBaseline from '@mui/material/CssBaseline';

import { isFeatureEnabled } from 'ff/common/ffAppUtils';

import { createStore } from './store';
import { DebriefApp } from './app';
import SharedDebriefApp from 'ff/debrief/share/ShareApp';
import { initialAppSliceState } from 'ff/debrief/features/AppSlice';

import renderFFMenu from '../common/renderFFMenu';
renderFFMenu();

const isEnabled = isFeatureEnabled('debrief_demo_page');

if (isEnabled) {
    const rootNode = document.getElementById('debrief-app');
    if (rootNode) {
        const root = createRoot(rootNode);
        root.render(
            <React.Fragment>
                <CssBaseline />
                <Provider store={createStore()}>
                    <DebriefApp />
                </Provider>
            </React.Fragment>
        );
    }
}

if (isEnabled) {
    const rootNode = document.getElementById('debrief-share-app');
    const initialState = {
        ...initialAppSliceState,
        isShareApp: true,
    };
    if (rootNode) {
        const root = createRoot(rootNode);
        root.render(
            <React.Fragment>
                <CssBaseline />
                <Provider store={createStore({ appSlice: initialState })}>
                    <SharedDebriefApp />
                </Provider>
            </React.Fragment>
        );
    }
}
